var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllBookings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9B9B9B",
    strokeLinecap: "round",
    strokeWidth: 2.083
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.908 24.673H6.536c-.796 0-1.442-.773-1.442-1.725V8.134c0-.953.646-1.725 1.442-1.725h18.372c.797 0 1.442.772 1.442 1.725v14.814c0 .952-.645 1.725-1.442 1.725zM20.706 12.016h-6.393m6.393 4.167h-6.393m6.393 4h-6.393m-3.607-8.167h-.5m.5 4.167h-.5m.5 4h-.5"
  }))));
}
export default SvgAllBookings;